export default __webpack_public_path__ + "static/bonfire-c7918a5ef368260478a9d2ce63317c84.jpg";